import React from "react";
import {
  FaSchool,
  FaBookOpen,
  FaFlask,
  FaDesktop,
  FaTheaterMasks,
  FaRunning,
} from "react-icons/fa";
const infrastructureData = [
  {
    title: "School Building",
    icon: <FaSchool />,
    desc: "A vast expanse of 3 acres provides a perfect ambience for an aesthetically chartered school building with open lawns, floral beauty and wi-fi enabled infrastructure comprising 90+ well ventilated classrooms.",
  },
  {
    title: "Libraries",
    icon: <FaBookOpen />,
    desc: "Three well equipped libraries including Junior, Middle and Senior School sections with a computerized reference library of 20,000+ books.",
  },
  {
    title: "Science Laboratories",
    icon: <FaFlask />,
    desc: "Fully equipped Physics, Chemistry and Biology labs helping students enhance scientific temperament and innovation skills.",
  },
  {
    title: "ICT Laboratories",
    icon: <FaDesktop />,
    desc: "Modern ICT labs for all levels where students learn computers, website designing and software basics.",
  },
  {
    title: "Auditorium",
    icon: <FaTheaterMasks />,
    desc: "A multipurpose auditorium for assemblies, functions, parent meetings, orientations and lecture sessions.",
  },
  {
    title: "Activity Hive",
    icon: <FaRunning />,
    desc: "Dedicated activity zone for dance classes, drama workshops, yoga sessions and indoor games.",
  },
];
const Infrastructure = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-24"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-24"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Our Schools
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            School{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Infrastructure
            </span>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Modern facilities designed to support academic excellence,
            creativity and overall development.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-8 items-start">
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-7 md:p-9 text-white shadow-2xl h-fit">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-3xl mb-6">
              <FaSchool />
            </div>
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight mb-5">
              A Campus Built For Better Learning
            </h3>
            <p className="text-white/90 text-sm md:text-base leading-8 mb-8">
              Our school infrastructure creates a safe, spacious and inspiring
              environment where students can learn, explore, perform and grow
              with confidence.
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4">
                <h4 className="text-2xl font-extrabold">3 Acres</h4>
                <p className="text-xs text-white/80 mt-1">Open Campus</p>
              </div>
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4">
                <h4 className="text-2xl font-extrabold">90+</h4>
                <p className="text-xs text-white/80 mt-1">Classrooms</p>
              </div>
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4">
                <h4 className="text-2xl font-extrabold">20k+</h4>
                <p className="text-xs text-white/80 mt-1">Books</p>
              </div>
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4">
                <h4 className="text-2xl font-extrabold">Wi-Fi</h4>
                <p className="text-xs text-white/80 mt-1">Enabled Campus</p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {infrastructureData.map((item, index) => (
              <div
                key={index}
                className="group bg-white rounded-[26px] p-6 shadow-xl border border-orange-100 hover:-translate-y-1 hover:shadow-2xl transition-all duration-300"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-14 h-14 min-w-[56px] rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 text-white flex items-center justify-center text-xl shadow-md group-hover:rotate-6 transition duration-300">
                    {item.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-extrabold text-gray-900">
                      {item.title}
                    </h3>
                    <div className="w-12 h-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-full mt-2"></div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-7 text-justify">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Infrastructure;